import { useEffect } from 'react'
import DatatableEvent, {
    DataTableEventParams,
} from 'components/DataTable/events/dataTableEvent'

const useDataTableEventSubscription = (
    handler: (param: DataTableEventParams) => void,
    whois?: string,
) => {
    useEffect(() => {
        const subscription = DatatableEvent.subscribe(handler)
        whois && console.log(`created sub:`, whois)
        return () => {
            whois && console.log(`do unsub:`, whois)
            subscription.unsubscribe()
        }
    }, [handler, whois])
}

export default useDataTableEventSubscription
